// src/Step7Summary.jsx
import React from 'react';

const GOAL_OPTIONS = [
  { value: '0', label: 'کاهش وزن' },
  { value: '1', label: 'عضله‌سازی' },
  { value: '2', label: 'تناسب اندام عمومی' },
  { value: '3', label: 'افزایش قدرت' },
  { value: '4', label: 'افزایش استقامت' },
  { value: '5', label: 'بازتوانی' },
];

const EXPERIENCE_OPTIONS = [
  { value: '0', label: 'بدون سابقه' },
  { value: '1', label: 'مبتدی' },
  { value: '2', label: 'متوسط' },
  { value: '3', label: 'پیشرفته' },
];

const ACTIVITY_OPTIONS = [
  { value: '0', label: 'کم' },
  { value: '1', label: 'متوسط' },
  { value: '2', label: 'زیاد' },
];

const ALLERGY_OPTIONS = [
  { value: '0', label: 'هیچ‌کدام' },
  { value: '1', label: 'گلوتن' },
  { value: '2', label: 'لبنیات' },
  { value: '3', label: 'آجیل' },
  { value: '4', label: 'تخم‌مرغ' },
];

const MEDICAL_OPTIONS = [
  { value: '0', label: 'هیچ‌کدام' },
  { value: '1', label: 'دیابت' },
  { value: '2', label: 'فشار خون' },
  { value: '3', label: 'بیماری قلبی' },
  { value: '4', label: 'مشکلات مفصلی' },
];

const EQUIPMENT_OPTIONS = [
  { value: '0', label: 'فقط وزن بدن' },
  { value: '1', label: 'وزن بدن + دمبل' },
  { value: '2', label: 'وزن بدن + کش' },
  { value: '3', label: 'باشگاه کامل' },
];

const BODY_FOCUS_OPTIONS = [
  { value: '0', label: 'کل بدن' },
  { value: '1', label: 'شکم و میان‌تنه' },
  { value: '2', label: 'بالاتنه' },
  { value: '3', label: 'پایین‌تنه' },
  { value: '4', label: 'پا و باسن' },
];

export default function Step7Summary({ form, colors }) {
  const isWorkoutOnly = Number(form.requestedPlan) === 1;
  const isDietOnly = Number(form.requestedPlan) === 2;
  const isSampleMode = Number(form.planType) === 0;

  return (
    <div>
      <SectionIntro
        colors={colors}
        title="مرور نهایی اطلاعات"
        subtitle={
          isSampleMode
            ? 'اطلاعاتت را بررسی کن. بعد از ادامه، نمونه‌ای از سبک برنامه‌ات نمایش داده می‌شود.'
            : 'اطلاعاتت را بررسی کن. بعد از ثبت، وارد مرحله پرداخت و ساخت برنامه می‌شی.'
        }
      />

      <div className="grid lg:grid-cols-2 gap-4">
        <SummaryCard title="مسیر انتخابی" colors={colors}>
          <SummaryItem
            label="نوع شروع"
            value={isSampleMode ? 'اول مشاهده نمونه برنامه' : 'دریافت مستقیم برنامه کامل'}
            colors={colors}
          />
          <SummaryItem
            label="برنامه انتخابی"
            value={getRequestedPlanLabel(form.requestedPlan)}
            colors={colors}
          />
          <SummaryItem
            label="هزینه نسخه کامل"
            value={formatTomanFa(form.price)}
            colors={colors}
          />
        </SummaryCard>

        <SummaryCard title="اطلاعات پایه" colors={colors}>
          <SummaryItem
            label="جنسیت"
            value={
              String(form.gender) === '0'
                ? 'مرد'
                : String(form.gender) === '1'
                ? 'زن'
                : '-'
            }
            colors={colors}
          />
          <SummaryItem label="سن" value={form.age || '-'} colors={colors} />
          <SummaryItem
            label="قد"
            value={form.height ? `${form.height} سانتی‌متر` : '-'}
            colors={colors}
          />
          <SummaryItem
            label="وزن"
            value={form.weight ? `${form.weight} کیلوگرم` : '-'}
            colors={colors}
          />
        </SummaryCard>

        <SummaryCard title="هدف و سابقه" colors={colors}>
          <SummaryItem
            label="هدف"
            value={lookupLabel(GOAL_OPTIONS, form.goal)}
            colors={colors}
          />
          <SummaryItem
            label="سابقه"
            value={lookupLabel(EXPERIENCE_OPTIONS, form.fitnessExperience)}
            colors={colors}
          />
          <SummaryItem
            label={isDietOnly ? 'تعداد روزها' : 'روزهای تمرین'}
            value={`${form.frequency} روز`}
            colors={colors}
          />
          {!isDietOnly && (
            <SummaryItem
              label="تمرکز برنامه"
              value={lookupLabel(BODY_FOCUS_OPTIONS, form.bodyFocus)}
              colors={colors}
            />
          )}
        </SummaryCard>

        <SummaryCard title={isDietOnly ? 'تغذیه و سلامتی' : 'سبک زندگی و سلامتی'} colors={colors}>
          <SummaryItem
            label="سطح فعالیت"
            value={lookupLabel(ACTIVITY_OPTIONS, form.activityLevel)}
            colors={colors}
          />

          {!isWorkoutOnly && (
            <SummaryItem
              label="آلرژی غذایی"
              value={lookupLabel(ALLERGY_OPTIONS, form.allergies)}
              colors={colors}
            />
          )}

          <SummaryItem
            label="شرایط پزشکی"
            value={lookupLabel(MEDICAL_OPTIONS, form.medicalConditions)}
            colors={colors}
          />
        </SummaryCard>

        {!isDietOnly && (
          <SummaryCard title="تجهیزات تمرین" colors={colors}>
            <SummaryItem
              label="امکانات تمرینی"
              value={lookupLabel(EQUIPMENT_OPTIONS, form.equipment)}
              colors={colors}
            />
          </SummaryCard>
        )}

        <SummaryCard title="اندازه‌ها" colors={colors}>
          <SummaryItem
            label="دور شکم"
            value={withUnit(form.measurements?.waist)}
            colors={colors}
          />
          <SummaryItem
            label="دور بازو"
            value={withUnit(form.measurements?.arm)}
            colors={colors}
          />
          <SummaryItem
            label="دور ران"
            value={withUnit(form.measurements?.thigh)}
            colors={colors}
          />
          <SummaryItem
            label="دور سینه"
            value={withUnit(form.measurements?.chest)}
            colors={colors}
          />
          <SummaryItem
            label="دور باسن"
            value={withUnit(form.measurements?.hip)}
            colors={colors}
          />
        </SummaryCard>
      </div>

      <div
        className="mt-5 rounded-2xl border px-4 py-4 text-sm leading-7"
        style={{
          borderColor: isSampleMode ? 'rgba(16,185,129,0.28)' : colors.border,
          backgroundColor: isSampleMode
            ? 'rgba(16,185,129,0.10)'
            : 'rgba(37,99,235,0.08)',
          color: colors.sub,
        }}
      >
        {isSampleMode
          ? 'بعد از این مرحله، نمونه‌ای از سبک برنامه‌ات را می‌بینی و بعد برای دریافت نسخه کامل تصمیم می‌گیری.'
          : 'بعد از ثبت درخواست، وارد صفحه پرداخت می‌شی و بعد از پرداخت، برنامه اختصاصی‌ات ساخته می‌شود.'}
      </div>
    </div>
  );
}

function SectionIntro({ title, subtitle, colors }) {
  return (
    <div
      className="mb-5 rounded-2xl border p-4"
      style={{
        borderColor: colors.border,
        backgroundColor: 'rgba(255,255,255,0.03)',
      }}
    >
      <h3 className="text-lg md:text-xl font-black mb-2">{title}</h3>
      <p className="text-sm leading-7" style={{ color: colors.sub }}>
        {subtitle}
      </p>
    </div>
  );
}

function SummaryCard({ title, children, colors }) {
  return (
    <div
      className="rounded-[22px] border p-4"
      style={{
        borderColor: colors.border,
        backgroundColor: colors.inputBg,
      }}
    >
      <h4 className="font-black mb-3">{title}</h4>
      <div className="space-y-0">{children}</div>
    </div>
  );
}

function SummaryItem({ label, value, colors }) {
  return (
    <div
      className="flex items-center justify-between gap-4 py-3 border-b last:border-b-0"
      style={{ borderColor: colors.border }}
    >
      <div className="text-sm" style={{ color: colors.sub }}>
        {label}
      </div>

      <div className="text-sm font-bold text-left" style={{ color: colors.text }}>
        {value || '-'}
      </div>
    </div>
  );
}

function lookupLabel(list, value) {
  const found = list.find((x) => String(x.value) === String(value));
  return found?.label ?? '-';
}

function getRequestedPlanLabel(value) {
  switch (Number(value)) {
    case 1:
      return 'برنامه تمرینی';
    case 2:
      return 'برنامه رژیم و تغذیه';
    case 3:
      return 'برنامه تمرین و رژیم غذایی';
    default:
      return '-';
  }
}

function formatTomanFa(n) {
  return `${Number(n || 0).toLocaleString('fa-IR')} تومان`;
}

function withUnit(value) {
  return value ? `${value} سانتی‌متر` : '-';
}